import { useMemo } from "react"
import { IntlShape } from "react-intl"
import { EButtonStyle } from "../../enums/animationSettings"
import { message } from "../../messages/animationSettings"

export default function useButtonStyleSelection(intl: IntlShape) {
    return useMemo(
        () => [
            {
                label: intl.formatMessage(message.combine),
                value: EButtonStyle.Combine,
            },
            {
                label: intl.formatMessage(message.separate),
                value: EButtonStyle.Separate,
            },

            {
                label: intl.formatMessage(message.none),
                value: EButtonStyle.None,
            },
        ],
        [intl],
    )
}
